import {createSlice} from "@reduxjs/toolkit";
import {getProductList} from "src/api/product";
import _ from "lodash";
import {addError} from "src/slices/errors";

const initialState = {
    productList: {},
    loadingProductList: false
};

const slice = createSlice({
    name: "product",
    initialState,
    reducers: {
        setLoadingProductList(state, action) {
            state.loadingProductList = action.payload;
        },
        setProductList(state, action) {
            const {productList} = action.payload;
            state.productList = productList;
        }
    }
});

export const reducer = slice.reducer;

export const loadProductList = () => async dispatch => {
    dispatch(slice.actions.setLoadingProductList(true));

    let productList = {};
    try {
        let getProductListResponse = await getProductList();
        _.forEach(getProductListResponse.data, value => {
            _.set(productList, `${value.code}`, value);
        });
    } catch (error) {
        dispatch(addError(error));
    }

    dispatch(slice.actions.setProductList({productList}));
    dispatch(slice.actions.setLoadingProductList(false));
};

export default slice;
